(function () {
  'use strict';

  // --- deterministic host script lookup ---
  var script =
    (document.currentScript && document.currentScript.dataset && document.currentScript.dataset.sprite && document.currentScript) ||
    document.getElementById('fa-inline-loader') ||
    document.querySelector('script[data-sprite]');

  if (!script) { console.warn('[fa-inline-icons] no <script data-sprite> found'); return; }

  var SPRITE_URL = script.getAttribute('data-sprite') || '';
  var FALLBACK_SPRITE_URL = script.getAttribute('data-fallback-sprite') || '';
  // PERF-FA-SPRITE-SUBSET-20260625: stale cached HTML may still point at the old full sprite.
  SPRITE_URL = SPRITE_URL.replace(/sprite-solid-v2\.svg(?=([?#]|$))/i, 'sprite-solid-v2-subset-20260625.svg');
  FALLBACK_SPRITE_URL = FALLBACK_SPRITE_URL.replace(/sprite-solid-v2\.svg(?=([?#]|$))/i, 'sprite-solid-v2-subset-20260625.svg');
  // PERF-FA-CORE-SPRITE-FALLBACK-20260625: load common icons first and fetch the larger subset only if a symbol is missing.
  if (!SPRITE_URL) { console.warn('[fa-inline-icons] data-sprite missing'); return; }

  // prevent double init per sprite
  window.__FA_INLINE_ICONS_SEEN__ = window.__FA_INLINE_ICONS_SEEN__ || {};
  if (window.__FA_INLINE_ICONS_SEEN__[SPRITE_URL]) return;
  window.__FA_INLINE_ICONS_SEEN__[SPRITE_URL] = true;

  var EXCLUDE = new Set(['fa','fa-solid','fa-regular','fa-brands','fa-fw','fa-sharp']);

  // FA4 -> FA6/7 name changes (add more if you hit them)
  var ALIASES = {
    'down-left-and-up-right-to-center': 'compress',
    'tools': 'screwdriver-wrench',
    'battery-bolt': 'battery-full',
    'shield-check': 'shield',
    'cogs': 'gears',
    'battery-slash': 'battery-empty',
    'calendar-alt': 'calendar-days',
    'play-circle': 'circle-play',
    'search': 'magnifying-glass',
    'shopping-cart': 'cart-shopping',
    'sign': 'sign-hanging',
    'sync-alt': 'arrows-rotate',
    'exclamation-circle': 'circle-exclamation',
    'arrow-circle-right': 'circle-arrow-right',
    'book-reader': 'book-open-reader',
    'candle-holder': 'fire',
    'exclamation-triangle': 'triangle-exclamation',
    'home': 'house',
    'lightbulb-on': 'lightbulb',
    'shield-alt': 'shield-halved',
    'balance-scale': 'scale-balanced',
    'hard-hat': 'helmet-safety',
    'pencil-ruler': 'pen-ruler',
    'map-marked-alt': 'map-location-dot',
    'lightbulb-o': 'lightbulb',
    'th-large': 'table-cells-large',
    'chalkboard-teacher': 'chalkboard-user',
    'globe-americas': 'earth-americas',
    'hand-paper': 'hand',
    'thermometer-three-quarters': 'temperature-three-quarters',
    'badge-check': 'circle-check',
    'bolt-slash': 'bolt',
    'cloud-smog': 'smog',
    'comments-question-check': 'comments',
    'compress-alt': 'down-left-and-up-right-to-center',
    'sparkles': 'wand-sparkles',
    'stream': 'bars-staggered',
    'temperature-snow': 'temperature-low',
    'turn-right': 'diamond-turn-right',
    'user-helmet-safety': 'helmet-safety',
    'check-circle': 'circle-check',
    'circle-info': 'info-circle',
    'info-circle': 'circle-info',
    'location-dot': 'map-marker-alt',
    'map-marker-alt': 'location-dot',
    'rotate-left': 'arrow-rotate-left',
    'undo': 'arrow-rotate-left',
    'undo-alt': 'arrow-rotate-left',
    'angle-double-left': 'angles-left',
    'angle-double-right': 'angles-right',
    'angle-double-up': 'angles-up',
    'angle-double-down': 'angles-down',
    'radiation-alt': 'radiation',
    'umbrella-water': 'water'
  };

  var RESOLVE_CACHE = {};
  var MISSING_SYMBOLS = {};
  var MISSING_SYMBOL_DETAILS = {};
  var UNRESOLVED_SYMBOLS_REPORTED = {};
  var FALLBACK_SPRITE_LOADED = false;
  var FALLBACK_SPRITE_PROMISE = null;
  var FALLBACK_SPRITE_FAILED = false;
  // FA-FALLBACK-RACE-20260719: share the pending fallback request before reporting unresolved symbols.

  function getIconClass(el) {
    if (!el || !el.classList) return null;
    for (var i = 0; i < el.classList.length; i++) {
      var c = el.classList[i];
      if (c.indexOf('fa-') === 0 && !EXCLUDE.has(c)) return c; // first icon-like class
    }
    return null;
  }

  function resolveSymbolId(rawId) {
    if (!rawId) return null;
    if (RESOLVE_CACHE[rawId]) return RESOLVE_CACHE[rawId];

    // strip leading "fa-" if present
    var base = rawId.replace(/^fa-/, '');
    // map FA4 names to FA6/7 where needed
    var mapped = ALIASES[base] || base;

    // Try the literal FA6 name before legacy aliases, then de-dupe.
    var candidates = [];
    var seen = {};
    var buildCandidates = [base, 'fa-' + base, mapped, 'fa-' + mapped];
    for (var candidateIndex = 0; candidateIndex < buildCandidates.length; candidateIndex++) {
      var candidate = buildCandidates[candidateIndex];
      if (candidate && !seen[candidate]) {
        seen[candidate] = true;
        candidates.push(candidate);
      }
    }
    for (var i = 0; i < candidates.length; i++) {
      if (document.getElementById(candidates[i])) {
        RESOLVE_CACHE[rawId] = candidates[i];
        return candidates[i];
      }
    }
    // not found yet - remember it and return mapped. A fallback sprite may fill it later.
    MISSING_SYMBOLS[mapped] = true;
    MISSING_SYMBOL_DETAILS[mapped] = { rawId: rawId, candidates: candidates.slice() };
    RESOLVE_CACHE[rawId] = mapped;
    return mapped;
  }

  function makeUseSvg(id, ariaHidden) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '1em');
    svg.setAttribute('height', '1em');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('focusable', 'false');
    if (ariaHidden == null) svg.setAttribute('aria-hidden', 'true'); else svg.setAttribute('aria-hidden', ariaHidden);

    var resolved = resolveSymbolId(id);
    var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', '#' + resolved);
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + resolved); // legacy Safari
    svg.appendChild(use);
    return svg;
  }

  function replaceNode(el) {
    if (!el || !el.classList || el.classList.contains('fa-svg')) return;
    var iconClass = getIconClass(el);
    if (!iconClass) return;
    var ah = el.getAttribute('aria-hidden');
    var svg = makeUseSvg(iconClass, ah);
    el.classList.add('fa-svg');
    el.textContent = '';
    el.appendChild(svg);
  }

  function processAll() {
    var nodes = document.querySelectorAll('.fa, .fa-solid, .fa-regular, .fa-brands, [class^="fa-"], [class*=" fa-"]');
    for (var i = 0; i < nodes.length; i++) replaceNode(nodes[i]);
  }

  function observe() {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var list = muts[m].addedNodes || [];
        for (var n = 0; n < list.length; n++) {
          var node = list[n];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.fa, .fa-solid, .fa-regular, .fa-brands, [class^="fa-"], [class*=" fa-"]')) {
            replaceNode(node);
          }
          if (node.querySelectorAll) {
            var q = node.querySelectorAll('.fa, .fa-solid, .fa-regular, .fa-brands, [class^="fa-"], [class*=" fa-"]');
            for (var j = 0; j < q.length; j++) replaceNode(q[j]);
          }
        }
        maybeLoadFallbackSprite();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function injectSprite(url) {
    return fetch(url, { credentials: 'omit', cache: 'force-cache' })
      .then(function (r) { if (!r.ok) throw new Error('sprite fetch failed: ' + r.status); return r.text(); })
      .then(function (svg) {
        var wrap = document.createElement('div');
        wrap.style.display = 'none';
        wrap.setAttribute('aria-hidden', 'true');
        wrap.innerHTML = svg;
        (document.body ? document.body : document.documentElement).insertBefore(
          wrap, (document.body && document.body.firstChild) ? document.body.firstChild : null
        );
      });
  }

  function hasMissingSymbols() {
    for (var id in MISSING_SYMBOLS) return true;
    return false;
  }

  // FA-BLOG-SUPPORT-20260713: defer warnings until all configured sprites have loaded.
  function warnUnresolvedSymbols() {
    for (var id in MISSING_SYMBOLS) {
      if (UNRESOLVED_SYMBOLS_REPORTED[id]) continue;
      var detail = MISSING_SYMBOL_DETAILS[id] || { rawId: id, candidates: [id, 'fa-' + id] };
      var found = false;
      for (var i = 0; i < detail.candidates.length; i++) {
        if (document.getElementById(detail.candidates[i])) { found = true; break; }
      }
      if (!found) {
        UNRESOLVED_SYMBOLS_REPORTED[id] = true;
        console.warn('[fa-inline-icons] symbol still not found after fallback:', detail.rawId, '-> tried:', detail.candidates.join(', '));
      }
    }
  }

  function maybeLoadFallbackSprite() {
    if (!hasMissingSymbols()) return Promise.resolve();
    if (FALLBACK_SPRITE_PROMISE) return FALLBACK_SPRITE_PROMISE;
    if (FALLBACK_SPRITE_LOADED || FALLBACK_SPRITE_FAILED) {
      warnUnresolvedSymbols();
      return Promise.resolve();
    }
    if (!FALLBACK_SPRITE_URL) {
      FALLBACK_SPRITE_FAILED = true;
      warnUnresolvedSymbols();
      return Promise.resolve();
    }
    FALLBACK_SPRITE_PROMISE = injectSprite(FALLBACK_SPRITE_URL)
      .then(function () {
        FALLBACK_SPRITE_LOADED = true;
      })
      .catch(function (error) {
        FALLBACK_SPRITE_FAILED = true;
        console.error('[fa-inline-icons] fallback sprite load error:', error);
      })
      .then(function () {
        warnUnresolvedSymbols();
        FALLBACK_SPRITE_PROMISE = null;
      });
    return FALLBACK_SPRITE_PROMISE;
  }

  function init() {
    injectSprite(SPRITE_URL).then(function () {
      processAll();
      maybeLoadFallbackSprite();
      observe();
    })
      .catch(function (e) { console.error('[fa-inline-icons] sprite load error:', e); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // LC-REQ-001: temporary Learning Center polish bridge for cached storefront HTML variants.
  function applyLearningCenterPolishBridge() {
    if (!/\/pages\/learning-center\/?$/.test(window.location.pathname)) return;

    var quote = document.querySelector('.announcement-bar-request-a-quote a');
        if (quote) {
          quote.classList.add('announcement-bar-request-a-quote__link');
          quote.innerHTML = "<span class=\"announcement-bar-request-a-quote__icon\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" focusable=\"false\"><path d=\"M8 3h6l4 4v14H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\"/><path d=\"M14 3v5h5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\"/><path d=\"M10 13h5M10 17h7\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></svg></span><span>Request a Quote</span>";
        }

    var subtitle = document.querySelector('#shopify-section-template--20148312375532__promotion_blocks_P8cMrQ .block-section-subtitle');
    if (subtitle) {
      subtitle.textContent = 'Guides, checklists and calculators for exit signs, emergency lights and egress safety - basics to advanced. Start with code requirements, then compare products, wiring, batteries, wet-location installs, testing, and inspection-ready maintenance.';
    }

    if (document.getElementById('lc-req-001-polish-bridge')) return;
    var style = document.createElement('style');
    style.id = 'lc-req-001-polish-bridge';
    style.textContent = [
      '.announcement-bar-request-a-quote a{display:inline-flex!important;align-items:center!important;min-height:28px!important;padding:5px 12px!important;border:1px solid rgba(255,255,255,.68)!important;border-radius:999px!important;color:inherit!important;font-size:.88rem!important;font-weight:800!important;line-height:1!important;text-decoration:none!important;white-space:nowrap!important}',
      '@media (min-width:990px){.announcement-bar{padding-top:.6rem!important;padding-bottom:.6rem!important}}',
      '#shopify-section-template--20148312375532__promotion_blocks_P8cMrQ .block-section{margin-top:24px!important;margin-bottom:28px!important}',
      '#shopify-section-template--20148312375532__promotion_blocks_P8cMrQ .block-block-section-title-wrapper{min-height:150px!important;padding-right:min(330px,34vw)!important;background-image:url(https://cdn.shopify.com/s/files/1/0067/8150/1528/t/28/assets/lc-req-001-learning-center-hero-flat.jpg?v=1781419435)!important;background-position:right center!important;background-size:min(280px,30vw) auto!important;background-repeat:no-repeat!important}',
      '#shopify-section-template--20148312375532__promotion_blocks_P8cMrQ .block-section-title-wrap{max-width:780px!important}',
      '@media (max-width:749px){#shopify-section-template--20148312375532__promotion_blocks_P8cMrQ .block-block-section-title-wrapper{min-height:0!important;padding-right:0!important;background-image:none!important}}',
      "/* LC-REQ-002 header bridge */",
      "/* LC-REQ-002: header quote CTA readability and icon sizing. */",
      ".announcement-bar { font-size: 1.3rem !important; }",
      ".announcement-bar-right { font-size: 1.3rem !important; font-weight: 800 !important; letter-spacing: 0 !important; }",
      ".announcement-bar-request-a-quote a { display: inline-flex !important; align-items: center !important; gap: 6px !important; min-height: 32px !important; padding: 7px 16px !important; border: 1px solid rgba(255, 255, 255, .72) !important; border-radius: 999px !important; color: inherit !important; font-size: 1.35rem !important; font-weight: 800 !important; line-height: 1 !important; text-decoration: none !important; white-space: nowrap !important; }",
      ".announcement-bar-request-a-quote__icon { display: inline-flex !important; flex: 0 0 auto !important; width: 1.4rem !important; height: 1.4rem !important; }",
      ".announcement-bar-request-a-quote__icon svg { display: block !important; width: 100% !important; height: 100% !important; }",
      ".announcement-bar-right .fa-solid { font-size: 1.2rem !important; vertical-align: -0.1em !important; }",
      "@media (max-width: 749px) { .announcement-bar-right { font-size: 1.2rem !important; } }",
    ].join('\n');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyLearningCenterPolishBridge);
  else applyLearningCenterPolishBridge();

})();
